import { makeActionCreator } from "@ec-oem/ec.oem.oa3.ui.core/utility"

export const INITIALIZE_APP ="actions/INITIALIZE_APP";
export const initializeApp = makeActionCreator(INITIALIZE_APP, false);